import type { FormDocument, FieldOption } from '@fulcrum/form-embedded';

// Demo clinical content lives in the host, not the library — see phq9.ts.

const SECTION_ID = 'gad7-section';

const LIKERT_OPTIONS: FieldOption[] = [
  { id: 'o0', value: '0', label: 'Not at all', order: 0, weight: 0 },
  { id: 'o1', value: '1', label: 'Several days', order: 1, weight: 1 },
  { id: 'o2', value: '2', label: 'More than half the days', order: 2, weight: 2 },
  { id: 'o3', value: '3', label: 'Nearly every day', order: 3, weight: 3 },
];

const ITEM_TEXT: string[] = [
  'Feeling nervous, anxious, or on edge',
  'Not being able to stop or control worrying',
  'Worrying too much about different things',
  'Trouble relaxing',
  'Being so restless that it is hard to sit still',
  'Becoming easily annoyed or irritable',
  'Feeling afraid, as if something awful might happen',
];

export const GAD7_DOCUMENT: FormDocument = {
  sections: [
    {
      id: SECTION_ID,
      name: 'GAD-7',
      label: 'GAD-7 Anxiety Screener',
      description: 'Over the last 2 weeks, how often have you been bothered by any of the following problems?',
      order: 0,
      fields: [
        ...ITEM_TEXT.map((text, i) => ({
          id: `gad7-q${i + 1}`,
          sectionId: SECTION_ID,
          label: `${i + 1}. ${text}`,
          handle: `gad${i + 1}`,
          fieldType: 'SCALE',
          order: i,
          isRequired: true,
          isHidden: false,
          options: LIKERT_OPTIONS,
        })),
        {
          id: 'gad7-total',
          sectionId: SECTION_ID,
          label: 'Total Score',
          handle: 'gad7_total',
          fieldType: 'CALC',
          order: ITEM_TEXT.length,
          isRequired: false,
          isHidden: false,
          calc: { aggregation: 'sum', sourceHandles: Array.from({ length: 7 }, (_, i) => `gad${i + 1}`) },
          clinicalCoding: { loincCode: '70274-6' },
        },
      ],
    },
  ],
};
